import type { IMissionCard } from 'api/cms/missions';
import type {
  IMissionProgressStreak,
  TMissionsProgressResponse,
} from 'api/missions';
import { useMemo } from 'react';
import { getStreakMission, isStreakMission } from '../helpers/streakMission';

interface IStreakMissionProps {
  streakImage: string | null;
  streak: IMissionProgressStreak | null;
  isStreak: boolean;
}

export const useStreakMission = (
  mission: IMissionCard,
  idleImage: string,
  progress?: TMissionsProgressResponse
): IStreakMissionProps => {
  const { backendId } = mission;

  return useMemo(() => {
    if (!isStreakMission(backendId)) {
      return { streakImage: null, streak: null, isStreak: false };
    }

    const config = getStreakMission(backendId);
    const missionProgress = progress?.[backendId];
    const streak = missionProgress?.streak ?? null;

    if (!(config && streak)) {
      return { streakImage: null, streak, isStreak: true };
    }

    const completedDays = Math.floor(
      (missionProgress?.progress ?? 0) / (100 / config.maxStreak)
    );
    const clampedStreak = Math.min(completedDays, config.maxStreak);

    const streakImage =
      missionProgress?.progress === 0
        ? idleImage
        : config.images[clampedStreak];

    return {
      streakImage,
      streak,
      isStreak: true,
    };
  }, [backendId, progress, idleImage]);
};
